// Note: This file is only used on the backend
// Frontend doesn't need Joi validation schemas

/**
 * Validation schema for Agent Output Parser parameters
 * Only available on backend where Joi is installed
 */
export const agentOutputParserSchema = (() => {
  // Check if we're in a Node.js environment (backend)
  if (typeof globalThis.window === 'undefined' && typeof require !== 'undefined') {
    try {
      // Dynamic import to avoid Vite trying to resolve this during build
      // Using Function constructor instead of eval to avoid build warnings
      const dynamicRequire = new Function('moduleName', 'return require(moduleName)');
      const Joi = dynamicRequire('joi');
      return Joi.object({
        schemaSource: Joi.string()
          .valid('example', 'manual')
          .default('example')
          .description('How to define the output schema'),
        
        jsonExample: Joi.string()
          .default('{\n  "name": "John Doe",\n  "age": 30,\n  "email": "john@example.com"\n}')
          .description('Example JSON structure'),
        
        jsonSchema: Joi.string()
          .default('{\n  "type": "object",\n  "properties": {\n    "name": { "type": "string" },\n    "age": { "type": "number" }\n  },\n  "required": ["name"]\n}')
          .description('JSON Schema definition'),
        
        schemaDescription: Joi.string()
          .allow('')
          .default('')
          .description('Description of schema purpose'),
        
        strictValidation: Joi.boolean()
          .default(true)
          .description('Enforce strict schema validation'),
        
        enableAutoFix: Joi.boolean()
          .default(true)
          .description('Attempt to fix JSON errors'),
        
        enableRetry: Joi.boolean()
          .default(true)
          .description('Retry with LLM if validation fails'),
        
        maxRetries: Joi.number()
          .min(1)
          .max(10)
          .default(3)
          .description('Maximum retry attempts'),
        
        retryPromptTemplate: Joi.string()
          .default('The previous output did not match the required format.\n\nRequired format:\n{instructions}\n\nYour previous output:\n{completion}\n\nError:\n{error}\n\nPlease provide the output again in the correct JSON format.')
          .description('Template for retry prompts'),
        
        onValidationFailure: Joi.string()
          .valid('error', 'partial', 'raw')
          .default('error')
          .description('Action on validation failure'),
        
        includeMetadata: Joi.boolean()
          .default(true)
          .description('Include validation metadata in output')
      }).unknown(true);
    } catch (e) {
      // Joi not available (frontend), return null
      return null;
    }
  }
  // Frontend environment, return null
  return null;
})();
